<template>
	<div class="child-privacy-policy min-h-screen bg-gray-100">
		<div class="child-privacy-policy-body max-w-3xl mx-auto bg-white shadow-md rounded-lg p-6 sm:p-8">
			<!-- 标题 -->
			<h1 class="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-4">{{ APP_DISPLAY_NAME }}儿童隐私保护政策</h1>

			<!-- 日期信息 -->
			<p class="text-gray-600 mb-6">
				更新日期：2026年1月20日
				<br />
				生效日期：2026年1月20日
			</p>

			<!-- 特别提示 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">特别提示</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<p>
						{{ COMPANY_NAME }}（以下简称"我们"）非常重视对儿童（指不满14周岁的未成年人，下同）个人信息和隐私安全的保护。我们将通过《{{ APP_DISPLAY_NAME }}儿童隐私保护政策》（以下简称"本政策"）向您说明我们处理儿童个人信息的相关规则。除另有说明外，本政策所用术语和缩略词与我们产品或服务所提供的单独的隐私政策（以下简称"产品隐私政策"）中的术语和缩略词涵义相同，与本政策如有不一致之处，以本政策为准；本政策未载明之处，则参照适用产品隐私政策。
					</p>
					<p>若您是儿童，请务必通知您的父母或其他监护人共同阅读本政策，并请您在使用我们的产品或服务前，取得您的父母或其他监护人的同意。</p>
					<p>
						若您是儿童的父母或其他监护人，您应当正确履行监护职责，保护儿童个人信息安全。若您监护的儿童本人需要注册或使用我们的产品或服务，在注册或使用前，请您务必仔细阅读本政策，并在确认充分理解并同意全部条款后再允许、指导、监督您监护的儿童使用我们的产品或服务。若您不同意本政策的条款，请您要求您监护的儿童即时停止使用我们的产品或服务。
					</p>
					<p>请注意，以下正文中的"您"，特指儿童的父母或其他监护人。</p>
					<p>本政策将帮助您了解以下内容：</p>
					<ul class="list-decimal pl-6 space-y-2">
						<li>我们如何收集和使用儿童的个人信息</li>
						<li>我们如何委托处理、共享、转让、公开披露儿童的个人信息</li>
						<li>我们如何保护儿童的个人信息</li>
						<li>我们如何存储儿童的个人信息</li>
						<li>您如何实现管理儿童个人信息的权利</li>
						<li>我们如何更新本政策</li>
						<li>如何联系我们</li>
						<li>其他</li>
					</ul>
				</div>
			</section>

			<!-- 一、我们如何收集和使用儿童个人信息 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">一、我们如何收集和使用儿童个人信息</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<ol class="list-decimal pl-6 space-y-4">
						<li>
							为了保护儿童个人信息安全，促进儿童健康成长，我们将依照《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《中华人民共和国未成年人保护法》《儿童个人信息网络保护规定》等法律法规的要求，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则收集和使用儿童的个人信息。
						</li>
						<li>
							当您为被监护的儿童选择使用我们的产品或服务时，我们可能需要向您收集您所监护儿童的个人信息，用于履行相关服务之必要。我们在收集前会事先告知您收集的目的、范围和用途，并取得您的单独同意。有关具体的收集和使用的详情请您查阅产品隐私政策"我们如何收集和使用您的个人信息"章节进行详细了解。
						</li>
						<li>我们也可能会通过Cookies和同类技术自动收集儿童的个人信息，具体请您查阅产品隐私政策"我们如何使用Cookies和同类技术"章节进行详细了解。</li>
						<li>
							当我们根据用户提供的上述信息识别出用户为儿童时，我们可能会收集您的联系方式，包括手机号码，并通过产品交互界面提示/短信/电话等方式与您沟通，验证您与您监护的儿童的监护关系。我们也可能会将您的账号与您监护的儿童的账号进行关联，以便保护您和您监护的儿童的个人信息权益。如涉及使用支付、购买权益等交易类的服务，我们可能会要求收集您的银行卡相关信息，并将该服务与您的银行卡相关信息进行绑定，以便您即时知晓和管控您监护的儿童的交易行为。如产品或服务涉及到录入指纹、人脸、声纹等身份验证功能，且该身份验证功能并非用于验证儿童个人身份的，我们强烈建议您替代您监护的儿童进行录入。
						</li>
						<li>当您要求您所监护的儿童终止使用我们的产品或服务后，我们会即时停止对儿童个人信息的收集和使用。</li>
						<li>部分情形下我们可能无法准确识别并判断处理的个人信息是否属于儿童个人信息，该类情形下我们将仅按照产品隐私政策列明的规则进行个人信息的收集和使用。</li>
					</ol>
				</div>
			</section>

			<!-- 二、我们如何委托处理、共享、转让、公开披露儿童个人信息 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">二、我们如何委托处理、共享、转让、公开披露儿童个人信息</h2>

				<div class="space-y-4">
					<div>
						<h3 class="text-lg font-medium text-gray-800 mb-2">1. 委托处理、共享</h3>
						<div class="text-gray-700 leading-relaxed space-y-4">
							<p>我们承诺对儿童的个人信息进行严格保密，不会将儿童的个人信息委托处理、共享给任何第三方（包括公司、组织和个人），但以下情形除外：</p>
							<ul class="list-decimal pl-6 space-y-2">
								<li>
									<strong>获取单独同意的情形</strong>
									：为了提供产品必要服务而需要委托处理或共享儿童个人信息的，我们会获得您的单独同意后，再将儿童的个人信息与其他第三方委托处理或共享。
								</li>
								<li>
									<strong>符合法定情形</strong>
									：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，将儿童的个人信息对外委托处理或共享。
								</li>
							</ul>
							<p>对于符合上述情形的，我们将在产品隐私政策"我们如何委托处理、共享、转让、公开披露您的信息"章节所述内容的基础上，采取如下措施进行保护：</p>
							<ul class="list-decimal pl-6 space-y-2">
								<li>我们会进行评估以保证此类情形的合法性和正当必要性，如必须委托处理或共享的，我们将评估受托和共享的第三方的资质。</li>
								<li>
									对我们委托处理、共享儿童个人信息的第三方公司、组织和个人，我们会与其签署严格的协议，明确双方责任、处理事项、处理期限、处理性质和目的等，委托行为不得超出授权范围，要求他们履行包括但不限于以下义务：
									<ul class="list-decimal pl-6 mt-2 space-y-1">
										<li>按照法律、行政法规的规定和我们的说明、本政策以及其他任何相关的保密和安全要求来处理儿童个人信息；</li>
										<li>禁止将这些第三方将儿童个人信息用于未经儿童父母或其他监护人授权同意的用途；</li>
										<li>协助我们回应儿童父母或其他监护人提出的申请；</li>
										<li>采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；</li>
										<li>委托关系解除时及时删除儿童个人信息；</li>
										<li>不得转委托和再次共享；</li>
										<li>其他依法应当履行的儿童个人信息保护义务。</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>

					<div>
						<h3 class="text-lg font-medium text-gray-800 mb-2">2. 转让</h3>
						<div class="text-gray-700 leading-relaxed space-y-4">
							<p>我们不会将儿童的个人信息转让给任何第三方（包括公司、组织和个人），但以下情形除外：</p>
							<ul class="list-decimal pl-6 space-y-2">
								<li>
									<strong>获取单独同意的情形</strong>
									：在获取您的单独同意的情况下转让；
								</li>
								<li>
									<strong>符合法定情形</strong>
									：根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行转让；
								</li>
								<li>
									<strong>合并、收购或破产清算情形</strong>
									：在本产品服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到儿童个人信息转让，我们会告知您接收方的名称或者姓名和联系方式，并要求新的持有儿童个人信息的接收方继续受本政策的约束，对于接收方变更原先的处理目的、处理方式的，我们将要求其重新征求您的单独同意。
								</li>
							</ul>
						</div>
					</div>

					<div>
						<h3 class="text-lg font-medium text-gray-800 mb-2">3. 公开披露</h3>
						<div class="text-gray-700 leading-relaxed space-y-4">
							<p>我们仅会在以下情况下，公开披露儿童的个人信息：</p>
							<ul class="list-decimal pl-6 space-y-2">
								<li>
									<strong>获取单独同意的情形</strong>
									：获得您单独同意或基于您的主动选择；
								</li>
								<li>
									<strong>符合法定情形</strong>
									：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
								</li>
								<li>
									<strong>违规情形</strong>
									：如果我们确定本产品使用者出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则披露关于儿童的个人信息，包括相关违规行为以及本产品已采取的措施。
								</li>
							</ul>
							<p>
								对于委托处理、共享、转让、公开披露的其他例外情形，适用于产品隐私政策"我们如何委托处理、共享、转让、公开披露您的信息"章节中"委托处理、共享、转让、公开披露个人信息时事先征得授权同意的例外"小节所述内容。
							</p>
						</div>
					</div>
				</div>
			</section>

			<!-- 三、我们如何保护儿童的个人信息 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">三、我们如何保护儿童的个人信息</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<p>我们采取一切合理可行的措施，保护儿童个人信息：</p>
					<ol class="list-decimal pl-6 space-y-4">
						<li>
							<strong>控制访问权限</strong>
							：对我们的工作人员以最小授权为原则，严格设定信息访问权限，控制儿童个人信息知悉范围。工作人员访问儿童个人信息的，应当经过部门个人信息保护负责人或者其授权的管理人员审批，记录访问情况，并采取技术措施，避免违法复制、下载儿童个人信息。
						</li>
						<li>
							<strong>规范事件响应</strong>
							：发现儿童个人信息发生或者可能发生泄露、毁损、丢失的，我们将立即启动应急预案，采取补救措施；造成或者可能造成严重后果的，我们会将事件相关情况以邮件、信函、电话、推送通知等方式告知受影响的儿童及其父母或其他监护人，难以逐一告知的，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。
						</li>
						<li>如您希望了解更多，请查阅产品隐私政策"我们如何保护您的个人信息"章节，我们将采取该章节中所列明的数据安全措施，保护儿童个人信息。</li>
					</ol>
				</div>
			</section>

			<!-- 四、我们如何存储儿童的个人信息 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">四、我们如何存储儿童的个人信息</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<ol class="list-decimal pl-6 space-y-4">
						<li>我们会将在中国境内收集和产生的儿童的个人信息存储在中国境内。我们不会将儿童的个人信息传输至中国境内以外地区。</li>
						<li>
							我们只会在达成产品隐私政策所述目的所需的期限内保留儿童的个人信息，除非可适用的法律法规或国家规范性文件另有规定。在超过上述期限，或您主动要求删除儿童个人信息或注销账号后，我们将根据适用法律法规的要求尽快删除个人信息，除非可适用的法律法规或国家规范性文件要求在更长的期间内保留这些信息。
						</li>
						<li>
							当我们的相关服务发生停止运营的情形时，我们将采取包括发送通知和公告形式通知到您和使用我们产品或服务的儿童，并在法律法规要求的期限内删除服务器中留存的儿童个人信息。
						</li>
					</ol>
				</div>
			</section>

			<!-- 五、我们如何管理儿童的个人信息的权利 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">五、我们如何管理儿童的个人信息的权利</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<ol class="list-decimal pl-6 space-y-4">
						<li>
							您有权查阅、更正、补充、删除、复制、转移您监护的儿童的个人信息以及有权改变授权同意的范围或撤回授权、注销账号、对自动化决策进行限制，您还拥有投诉和获得我们回复的权利。为方便您在使用我们的产品或服务期间可以便捷地管理儿童个人信息，我们在产品中提供了相应的路径，具体地，请按照产品隐私政策中的"您如何实现管理您个人信息的权利"章节内容进行操作。
						</li>
						<li>
							您也可以通过本政策第七章节所述的联系方式与我们的客服进行联系并完成各项操作，请您理解，出于安全考虑，我们会在收到您的申请后对您的身份进行核实，在核实过程中，我们可能需要您提供有关您及您监护儿童的账号、产品使用等情况的相关信息，以完成身份验证和问题核实。
						</li>
						<li>
							根据相关法律法规的要求，对于您要求我们删除其收集、存储、使用、披露的儿童个人信息的，我们将及时采取措施予以删除，包括但不限于以下情形：
							<ul class="list-decimal pl-6 mt-2 space-y-1">
								<li>您撤回同意的；</li>
								<li>儿童或您通过注销等方式终止使用产品或者服务的。</li>
							</ul>
						</li>
					</ol>
				</div>
			</section>

			<!-- 六、我们如何更新本政策 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">六、我们如何更新本政策</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<p>我们可能会根据我们的产品或服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分，我们会在专门页面上展示最新修改版本。</p>
					<p>对于重大变更，我们还会提供更为显著的通知，具体地，请参照产品隐私政策"我们如何更新本政策"的内容。</p>
				</div>
			</section>

			<!-- 七、如何联系我们 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">七、如何联系我们</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<p>
						为更好地保护您的个人信息，我们设立有专门的网络安全与个人信息保护部门。如您在使用我们的产品或服务的过程中对本政策或对您的个人信息有任何疑问或建议，请通过以下联系方式与我们联系：
					</p>
					<ul class="list-disc pl-6 space-y-2">
						<li>
							<strong>联系电话</strong>
							：{{ CONTACT_PHONE }}
						</li>
						<li>
							<strong>联系邮箱（个人信息保护负责人）</strong>
							：
							<a :href="'mailto:' + CONTACT_EMAIL" class="text-blue-600 hover:underline">{{ CONTACT_EMAIL }}</a>
						</li>
						<li>
							<strong>联系地址</strong>
							：{{ CONTACT_ADDRESS }}
						</li>
					</ul>
					<p>
						如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您或您监护的儿童的合法权益，且在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。
					</p>
				</div>
			</section>

			<!-- 八、其他 -->
			<section class="mb-8">
				<h2 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">八、其他</h2>
				<div class="text-gray-700 leading-relaxed space-y-4">
					<p>与本政策相关的任何纠纷，双方应经友好协商解决；若不能协商解决，您在此同意将争议提交至中国广州仲裁委员会裁决。仲裁裁决是终局的，对双方均有约束力。</p>
					<p>如果有管辖权的仲裁机构裁决本政策的任何条款无效，则该条款将从本政策中移除，但该条款的无效不影响本政策其余条款的效力。本政策的其余条款将继续执行。</p>
				</div>
			</section>

			<!-- 返回链接 -->
			<div class="border-t border-gray-200 pt-6 mt-8">
				<a href="/privacy.html" class="text-blue-600 hover:underline text-sm font-medium">← 返回隐私政策</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { APP_DISPLAY_NAME, COMPANY_NAME, CONTACT_PHONE, CONTACT_EMAIL, CONTACT_ADDRESS } from '@/config/app'
</script>
